import { createContext, ReactNode, useContext, useMemo } from 'react';


type AnalyticsTracker = {
  track: (eventName: string, properties?: Record<string, string>) => void;
};

const AnalyticsContext = createContext<AnalyticsTracker>({
  track: () => undefined,
});

function createTracker(): AnalyticsTracker {
  return {
    track: (eventName, properties) => {
      const globalWindow = window as Window & { posthog?: { capture: (event: string, props?: unknown) => void } };
      globalWindow.posthog?.capture(eventName, properties);
    },
  };
}

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  const tracker = useMemo(() => createTracker(), []);
  return <AnalyticsContext.Provider value={tracker}>{children}</AnalyticsContext.Provider>;
}

export function useAnalytics() {
  return useContext(AnalyticsContext);
}

